import React, { memo } from 'react';
import { BlogPost, BlogMeta } from '@/services/blogService';
import { ResponsiveProvider, useResponsive } from '../BlogUtils/ResponsiveUtils';
import { BlogTemplate } from './BlogTemplate';
import { MobileNavigation } from '../BlogUtils/MobileNavigation';

interface ResponsiveBlogWrapperProps {
  post: BlogPost;
  relatedPosts: BlogMeta[];
  children?: React.ReactNode;
  onBack?: () => void;
}

const BlogContent: React.FC<ResponsiveBlogWrapperProps> = memo(({
  post,
  relatedPosts,
  children,
  onBack
}) => {
  const { isMobile } = useResponsive();

  return (
    <div className="relative">
      {/* Mobile Navigation */}
      {isMobile && (
        <MobileNavigation 
          post={post} 
          onBack={onBack}
        />
      )}
      
      {/* Main Blog Template */}
      <div className={isMobile ? 'pt-16' : ''}>
        <BlogTemplate 
          post={post} 
          relatedPosts={relatedPosts}
        >
          {children}
        </BlogTemplate>
      </div>
    </div>
  );
});

BlogContent.displayName = 'BlogContent';

export const ResponsiveBlogWrapper: React.FC<ResponsiveBlogWrapperProps> = ({
  post,
  relatedPosts,
  children,
  onBack
}) => {
  return (
    <ResponsiveProvider>
      <BlogContent 
        post={post}
        relatedPosts={relatedPosts}
        onBack={onBack}
      >
        {children}
      </BlogContent>
    </ResponsiveProvider>
  );
};

export default ResponsiveBlogWrapper;